import { Box, Paper } from '@material-ui/core'

export const BlankSection = () => {
  return <Box component={Paper} padding={'20px'} minHeight="200px"></Box>
}
export default BlankSection
